import React from 'react';
import { LegalPageLayout } from '../legal/LegalPageLayout';

export function CommunityGuidelines() {
  return (
    <LegalPageLayout
      title="Community Guidelines"
      meta="Last updated: 11 August 2025 · Tarana Media Private Limited"
    >
      <section className="terms-section" id="introduction">
                  <h2 className="terms-h2">
                    1. Introduction
                  </h2>
      
                  <h3 className="terms-h3">
                    1.1. Our Mission and Guiding Principles
                  </h3>
                  <p>
                    Tarana is designed as an all-in-one music platform that connects a
                    diverse ecosystem of users, including Artists and Creators,
                    Listeners, and Organizations. The platform's mission is to empower
                    creative professionals to collaborate, share, and monetize their
                    work while providing a vibrant space for fans to engage with
                    content and hire talent directly.To fulfill this mission, Tarana
                    is built on a foundation of four core principles: creative
                    integrity, respect, safety, and transparency. These principles
                    form the basis for all rules and policies that govern behavior and
                    content on the platform. These guidelines aim to foster a positive
                    and productive environment where creativity can flourish free from
                    harassment, fraud, and legal infringement.
                  </p>
      
                  <h3 className="terms-h3">
                    1.2. The Legal Relationship with the Terms of Use
                  </h3>
                  <p>
                    These Community Guidelines are a legally binding extension of the
                    Tarana Terms of Use ("Terms"). By accessing or using the Services,
                    all users agree to be bound by the Terms, which explicitly
                    reference these Community Guidelines and other policies. This
                    legal framework is a critical safeguard for the platform and its
                    users. It means that any violation of the Community Guidelines is,
                    by definition, a breach of the legally binding contract between
                    the user and Tarana. This direct legal linkage provides a solid
                    foundation for the platform to enforce its rules and take action
                    against non-compliant users, including content removal, account
                    suspension, or permanent termination, as stipulated in the Terms.
                    The guidelines provide specific, actionable rules of conduct that
                    operationalize the broader legal obligations outlined in the Terms
                    of Use, ensuring a consistent and defensible approach to platform
                    governance.
                  </p>
      
                  <h3 className="terms-h3">
                    1.3. Scope and Applicability
                  </h3>
                  <p>
                    The Community Guidelines apply to all users of Tarana, regardless
                    of their user type—Listeners, Artists & Creators, or Business
                    Accounts. The guidelines govern all user-generated content (UGC),
                    which is defined as any and all audio, video, text, graphics, and
                    other materials uploaded, submitted, or posted on the platform.
                    This includes music tracks, video content, artist profiles, social
                    media posts, comments, direct messages, and any other form of user
                    submission. The guidelines a lso extend to user behavior and
                    interactions across all features, including the music streaming
                    service, the social networking tools, the collaboration features,
                    and the freelance marketplace. This comprehensive scope ensures a
                    consistent standard of conduct throughout the entire Tarana
                    ecosystem.
                  </p>
                </section>
      
                {/* 2. Core Community Standards */}
                <section className="terms-section" id="core-standards">
                  <h2 className="terms-h2">
                    2. Core Community Standards: Prohibited Content &amp; Behavior
                  </h2>
      
                  {/* 2.1 Hate Speech and Discrimination */}
                  <h3 className="terms-h3">
                    2.1. Hate Speech and Discrimination
                  </h3>
                  <p>
                    Tarana has a zero-tolerance policy for hate speech. Hate speech is
                    defined as content that promotes violence, incites hatred, or
                    disparages individuals or groups based on protected
                    characteristics such as race, ethnicity, national origin, caste,
                    sexual orientation, gender, gender identity or expression,
                    religious affiliation, age, disability, or serious disease. This
                    policy is designed to create a safe and inclusive environment for
                    all community members.
                  </p>
                  <p>
                    Prohibited actions include, but are not limited to, using
                    dehumanizing statements about a person or group based on protected
                    characteristics, promoting or glorifying hate groups and their
                    associated images or symbols, and praising or calling for violence
                    against an individual or group. The use of hateful imagery, logos,
                    or profanity for the purpose of harassment or abuse is also
                    strictly prohibited. These specific prohibitions, drawn from
                    industry best practices, are intended to provide clarity and
                    prevent ambiguity in enforcement. The detailed definition of hate
                    speech and discrimination serves as a proactive legal safeguard,
                    demonstrating the platform’s commitment to combating systemic
                    discrimination and minimizing legal exposure.
                  </p>
      
                  {/* 2.2 Violence, Threats, and Graphic Content */}
                  <h3 className="terms-h3">
                    2.2. Violence, Threats, and Graphic Content
                  </h3>
                  <p>
                    Content that depicts, glorifies, or incites violence, or that
                    encourages serious physical harm, is strictly prohibited. This
                    includes, but is not limited to, incitement or threats of serious
                    physical harm or acts of violence against a specific target or
                    group.
                  </p>
                  <p>
                    Furthermore, Tarana will not permit content that encourages,
                    promotes, or glorifies suicide and self-harm. The platform is
                    committed to a policy of prevention and will provide resources for
                    users struggling with these issues. The guidelines also prohibit
                    graphic or gratuitous depictions of violence, gore, or other
                    shocking imagery, such as severely mutilated bodies or the
                    promotion of animal cruelty. This includes both explicit
                    depictions in video and audio, as well as detailed descriptions in
                    text.
                  </p>
      
                  {/* 2.3 Sexually Explicit and Obscene Material */}
                  <h3 className="terms-h3">
                    2.3. Sexually Explicit and Obscene Material
                  </h3>
                  <p>
                    Tarana maintains a strict policy against sexually explicit and
                    obscene material. A zero-tolerance policy is enforced for all
                    content related to child sexual abuse material (CSAM), and any
                    such content will be immediately reported to the appropriate
                    authorities.
                  </p>
                  <p>
                    Prohibited content includes pornography or visual depictions of
                    genitalia or nudity presented for the purpose of sexual
                    gratification. The platform also bans content that advocates for,
                    glorifies, or promotes sexual themes related to rape, incest, or
                    bestiality. This policy ensures that the platform remains a
                    professional environment suitable for all ages, while also
                    protecting the most vulnerable users from exploitation.
                  </p>
      
                  {/* 2.4 Intellectual Property Rights & Infringement */}
                  <h3 className="terms-h3">
                    2.4. Intellectual Property Rights &amp; Infringement
                  </h3>
                  <p>
                    The integrity of intellectual property is a cornerstone of the
                    Tarana platform. As a user, you retain all ownership rights in
                    your original content, but by uploading it, you explicitly warrant
                    that you either own the content or have obtained all necessary
                    rights, licenses, and permissions for its intended use on the
                    platform. The music industry involves a complex web of rights,
                    including master use, public performance, mechanical, and
                    synchronization rights, and users are responsible for securing all
                    of these for their uploaded content.
                  </p>
                  <p>
                    Any material that violates the intellectual property rights of
                    others, including copyrights and trademarks, is considered
                    infringing content and is strictly prohibited. Tarana provides
                    clear and accessible mechanisms for users to report content they
                    believe violates their intellectual property rights. Valid reports
                    will result in the immediate removal or restriction of the content
                    to prevent harm to creators and to maintain compliance with legal
                    frameworks. This approach reinforces the user's responsibility
                    while providing a clear recourse for rights holders, a crucial
                    element for a platform that acts as an intermediary for
                    user-generated content.
                  </p>
      
                  {/* 2.5 Spam, Fraud, and Deceptive Practices */}
                  <h3 className="terms-h3">
                    2.5. Spam, Fraud, and Deceptive Practices
                  </h3>
                  <p>
                    To maintain platform integrity and user trust, any form of fraud,
                    deception, or spam is prohibited. This includes:
                  </p>
                  <ul className="terms-list">
                    <li>
                      <strong>Impersonation:</strong> Users are forbidden from
                      impersonating any person, brand, or organization in a manner
                      that is intended or likely to deceive. This includes replicating
                      another user's name, stage name, image, or description, or using
                      a name or logo similar to a known brand without permission.
                    </li>
                    <li>
                      <strong>Fake Engagement:</strong> The manipulation of platform
                      metrics is strictly prohibited. Users may not use automated
                      means, such as bots or scripts, to artificially inflate play
                      counts, downloads, ratings, or reviews. The offering or
                      accepting of compensation or other incentives for these purposes
                      is also a violation.
                    </li>
                    <li>
                      <strong>Misinformation and Scams:</strong> Content that is
                      misleading, deceptive, or intended to scam or defraud other
                      users is not permitted. This includes phishing attempts,
                      malicious links, or any content that seeks to collect sensitive
                      information deceptively. The platform also prohibits the use of
                      "deepfakes" or other altered media that could pose a risk of
                      harm by misrepresenting a person's actions or words.
                    </li>
                  </ul>
      
                  {/* 2.6 Privacy and Confidential Information */}
                  <h3 className="terms-h3">
                    2.6. Privacy and Confidential Information
                  </h3>
                  <p>
                    Users must not share the private personal details of another
                    person or entity without their explicit permission. This includes,
                    but is not limited to, names, private conversations, photographs,
                    credit card numbers, health information, unlisted phone numbers,
                    and home or email addresses. Violations of this policy will be
                    treated with the utmost seriousness, as they directly undermine
                    the safety and trust of the community.
                  </p>
      
                  {/* 2.7 Illegal and Regulated Activities */}
                  <h3 className="terms-h3">
                    2.7. Illegal and Regulated Activities
                  </h3>
                  <p>
                    Tarana has a zero-tolerance policy for illegal activities. The
                    platform may not be used to promote or commit any illegal act, nor
                    to promote the sale of illegal or regulated goods or services.
                    This includes, but is not limited to, the sale of illegal
                    firearms, illegal drugs, or endangered species. Any content that
                    violates applicable local, national, or international laws and
                    regulations will be removed, and the associated account may be
                    subject to immediate and permanent termination.
                  </p>
                </section>
      
                {/* 3. Rules for Tarana's Features and Services */}
                <section className="terms-section" id="rules-features">
                  <h2 className="terms-h2">
                    3. Rules for Tarana's Features and Services
                  </h2>
      
                  {/* 3.1 Guidelines for Social Networking & Engagement */}
                  <h3 className="terms-h3">
                    3.1. Guidelines for Social Networking &amp; Engagement
                  </h3>
                  <p>
                    Tarana's social features, including user profiles, feeds,
                    comments, and direct messaging, are intended to foster respectful
                    interaction and constructive dialogue. The platform emphasizes the
                    following behavioral expectations:
                  </p>
                  <ul className="terms-list">
                    <li>
                      <strong>Constructive Feedback:</strong> While honest feedback is
                      encouraged as an essential part of the creative process, it must
                      always be presented constructively. Feedback should focus on the
                      content itself and not be directed at harassing, attacking, or
                      demeaning the individual who created it. Users are encouraged to
                      consider whether they would appreciate receiving similar
                      feedback before posting it.
                    </li>
                    <li>
                      <strong>Respectful Interaction:</strong> Users are expected to
                      show respect for other members of the community. Comments and
                      messages should not be off-topic, profane, abusive, or
                      harassing. If a user is blocked by another account, they are
                      forbidden from attempting to contact that user from a different
                      account.
                    </li>
                    <li>
                      <strong>Account Etiquette:</strong> The guidelines prohibit
                      “spamming” the community with repetitive comments or engaging in
                      repetitive follow/unfollow behavior. This disrupts the user
                      experience and is considered a form of abuse.
                    </li>
                  </ul>
      
                  {/* 3.2 Guidelines for the Freelance Marketplace */}
                  <h3 className="terms-h3">
                    3.2. Guidelines for the Freelance Marketplace
                  </h3>
                  <ul className="terms-list">
                    <li>
                      <strong>Professional Conduct:</strong> Both clients and service
                      providers are expected to act with professionalism and
                      integrity. This includes clear communication, fulfilling
                      contractual obligations, and adhering to agreed-upon timelines
                      and specifications for delivered work. Service providers are
                      responsible for delivering work as agreed, while clients are
                      responsible for prompt payment.
                    </li>
                    <li>
                      <strong>Prohibition on Circumvention of Payments:</strong>A
                      cornerstone of the platform’s legal and financial protection is
                      the mandatory use of the Tarana escrow system for all freelance
                      project payments. The guidelines unequivocally prohibit offering
                      or accepting payments outside of the platform. This rule is a
                      critical risk-management tool. It allows Tarana to protect both
                      clients and freelancers through the escrow system, which
                      securely holds funds until a project is approved, and it
                      insulates the platform from liability in disputes over
                      off-platform payments or fraud. Violation of this rule is a
                      severe breach of the Terms of Use and will result in strict
                      enforcement actions, including account termination.
                    </li>
                    <li>
                      <strong>Marketplace Integrity:</strong> Any attempt to
                      manipulate the marketplace, such as soliciting fake reviews,
                      engaging in fraudulent bidding practices, or misrepresenting a
                      profile or portfolio, is strictly forbidden.
                    </li>
                  </ul>
      
                  {/* 3.3 Guidelines for Collaboration and "Band" Projects */}
                  <h3 className="terms-h3">
                    3.3. Guidelines for Collaboration and "Band" Projects
                  </h3>
                  <ul className="terms-list">
                    <li>
                      <strong>Content and Ownership:</strong>When a user uploads or
                      creates content within a Band, only the creditors of that
                      content hold the rights to copy, download, modify, perform, and
                      commercialize that content for the purpose of the Band’s
                      activities on the platform. Individual users retain ownership of
                      their original contributions, but the shared nature of the work
                      means that a user may not be able to delete Band Content, even
                      if they contributed it, once it has been integrated into a
                      collaborative project.
                    </li>
                    <li>
                      <strong>Band Agreements and Revenue Splits:</strong>Tarana
                      provides integrated features for managing revenue splits and
                      ownership percentages. The platform facilitates the distribution
                      of revenues according to the percentages configured by the Band
                      members. However, for other internal team dynamics and specific
                      usage rights not managed by Tarana's system, it is highly
                      recommended that Band members enter into a separate, explicit
                      "Band Agreement" outside of the platform's Terms. Tarana's role
                      is strictly as a facilitator for the configured splits and it
                      does not act as a legal arbiter for disputes arising from these
                      private arrangements.
                    </li>
                    <li>
                      <strong>Leaving a Band:</strong> C If a user leaves a Band, the
                      content they contributed generally remains available for use by
                      the remaining members. This is an important consideration for
                      any user before contributing to a collaborative project.
                    </li>
                    <li>
                      <strong>Forking Content:</strong> Any Band member may also
                      change the setting on Band Content to allow for "forking," which
                      enables other users to create derivative works from it. The Band
                      is responsible for reaching a clear agreement among its members
                      before making any Band Content "forkable."
                    </li>
                    <li>
                      <strong>Band Termination:</strong> Only the designated Band
                      Owner can delete a Band. Once a Band is deleted, all associated
                      Band Content is removed from Tarana. Users are responsible for
                      exporting and saving any Band Content to their local devices if
                      they wish to ensure unrestricted access to it after a Band is
                      deleted.
                    </li>
                  </ul>
                </section>
      
                {/* 4. Enforcement, Reporting, and Consequences */}
                <section className="terms-section" id="enforcement-reporting">
                  <h2 className="terms-h2">
                    4. Enforcement, Reporting, and Consequences
                  </h2>
      
                  {/* 4.1 Our Multi-Layered Moderation Approach */}
                  <h3 className="terms-h3">
                    4.1. Our Multi-Layered Moderation Approach
                  </h3>
                  <p>
                    Tarana employs a comprehensive, multi-layered approach to content
                    moderation. This system is designed to proactively detect
                    violations while also providing users with a clear and reliable
                    method for reporting problematic content. The moderation stack
                    includes:
                  </p>
                  <ul className="terms-list">
                    <li>
                      <strong>User Reporting:</strong> Tarana provides clear and
                      accessible mechanisms for users to report content they believe
                      violates the Community Guidelines, Terms of Use, or their
                      intellectual property rights. User reports are a critical
                      component of the moderation process and are treated with
                      seriousness.
                    </li>
                    <li>
                      <strong>Human Moderation:</strong> A dedicated team of trained
                      human moderators reviews all flagged content and user reports.
                      This team makes final decisions based on a consistent
                      interpretation of the Community Guidelines, ensuring a fair and
                      nuanced approach that accounts for context.
                    </li>
                  </ul>
      
                  {/* 4.2 How to Report Violations */}
                  <h3 className="terms-h3">
                    4.2. How to Report Violations
                  </h3>
                  <p>
                    To report a violation, users should use the designated in-app
                    reporting tools. These tools are designed to be user-friendly and
                    to guide users through the process of submitting a detailed
                    report. For intellectual property claims, a specific procedure is
                    available to ensure that all necessary information, such as proof
                    of ownership, is provided to facilitate a swift and legally
                    compliant takedown.
                  </p>
      
                  {/* 4.3 The Consequences for Violations */}
                  <h3 className="terms-h3">
                    4.3. The Consequences for Violations
                  </h3>
                  <p>
                    Tarana utilizes a tiered system of penalties based on the severity
                    and frequency of the violation. This ensures that enforcement
                    actions are proportional to the offense. The consequences for
                    violating the Community Guidelines and/or the Terms of Use can
                    range from minor to severe, and they are clearly outlined to
                    ensure consistency and fairness.
                  </p>
                  <ul className="terms-list">
                    <li>
                      <strong>Content Removal:</strong> For most first-time and minor
                      violations, such as a single instance of spam or inappropriate
                      language, the violating content will be removed. The user may
                      receive an official warning.
                    </li>
                    <li>
                      <strong>Temporary Account Suspension:</strong> For repeated
                      policy violations or a serious first-time offense, a user’s
                      account may be temporarily suspended. During this period, the
                      user will lose access to platform features and may be unable to
                      post or interact with others.
                    </li>
                    <li>
                      <strong>Permanent Account Termination:</strong> Severe or
                      repeated violations will result in the permanent termination of
                      the user’s account. This action is reserved for the most serious
                      offenses, including but not limited to, the uploading of child
                      sexual abuse material, a severe and repeated pattern of hate
                      speech, fraud, or promoting dangerous activities. A permanent
                      ban results in the loss of access to all funds, features, and
                      uploaded content, and the user is prohibited from creating new
                      accounts on the platform.
                    </li>
                  </ul>
                </section>
      
                {/* 5. Consequences for KYC Non-Compliance */}
                <section className="terms-section" id="kyc-non-compliance">
                  <h2 className="terms-h2">
                    5. Consequences for KYC Non-Compliance
                  </h2>
                  <p>
                    The Terms of Use mandate a robust Know Your Customer (KYC)
                    verification process for all creators, freelancers, and anyone
                    receiving payouts. This is a critical security and fraud
                    prevention measure. A failure to complete mandatory KYC, the
                    submission of fraudulent information, or non-compliance with
                    periodic re-verification requirements will be considered a severe
                    violation of the platform’s policies. This will result in
                    immediate restrictions on monetization, payouts, and access to
                    specific services. In cases of persistent non-compliance or
                    fraudulent activity, Tarana reserves the right to terminate the
                    user’s account.
                  </p>
                </section>
      
                {/* 6. Appendix: Legal and Operational Frameworks */}
                <section className="terms-section" id="appendix">
                  <h2 className="terms-h2">
                    6. Appendix: Legal and Operational Frameworks
                  </h2>
      
                  {/* 6.1 Tarana’s Role as an Intermediary */}
                  <h3 className="terms-h3">
                    6.1. Tarana’s Role as an Intermediary
                  </h3>
                  <p>
                    Tarana operates as an "intermediary" or "hosting service provider"
                    for user-generated content. This legal classification is
                    significant and places specific due diligence obligations on the
                    platform under relevant international regulations, including the
                    European Union's Digital Services Act (DSA) and India's
                    Information Technology (Intermediary Guidelines and Digital Media
                    Ethics Code) Rules, 2021 (IT Rules). The Community Guidelines and
                    the associated enforcement procedures are specifically designed to
                    comply with these regulations. By proactively identifying and
                    removing violating content in a consistent, transparent manner,
                    Tarana seeks to uphold its legal obligations and maintain safe
                    harbor protections from liability for the content that users post.
                    This strategic alignment of policy and regulatory requirements is
                    essential for the long-term viability and legal stability of the
                    platform.
                  </p>
      
                  {/* 6.2 Glossary of Key Terms */}
                  <h3 className="terms-h3">
                    6.2. Glossary of Key Terms
                  </h3>
                  <ul className="terms-list">
                    <li>
                      <strong>Tarana:</strong> Refers to Tarana Media Private Limited.
                    </li>
                    <li>
                      <strong>Account:</strong> A user account created on the Tarana
                      Platform.
                    </li>
                    <li>
                      <strong>Artist:</strong> A user who creates, uploads, shares,
                      collaborates on, and monetizes their original music and video
                      content.
                    </li>
                    <li>
                      <strong>Band:</strong> A designated group of users formed on the
                      platform for the purpose of co-creating, collaborating, and
                      monetizing content as a team.
                    </li>
                    <li>
                      <strong>Content:</strong> Any and all audio, video, text,
                      graphics, images, data, and other materials uploaded or made
                      available through the Services.
                    </li>
                    <li>
                      <strong>Listener:</strong> A user who primarily engages with
                      artists, streams content, and can hire artists directly.
                    </li>
                    <li>
                      <strong>Organization:</strong> An entity (e.g., record label)
                      that uses the Services to manage teams, coordinate projects, and
                      collaborate with artists.
                    </li>
                    <li>
                      <strong>Services:</strong> All products, services, features, and
                      functionalities offered by Tarana.
                    </li>
                    <li>
                      <strong>User:</strong> Any individual or entity that accesses or
                      uses any part of the Services.
                    </li>
                    <li>
                      <strong>User-Generated Content (UGC):</strong> Any content
                      uploaded, submitted, or posted by users on the platform.
                    </li>
                  </ul>
      
                  {/* 5.3. Prohibited Content and Examples */}
                  <section className="terms-section" id="prohibited-content">
                    <h3 className="terms-h3">
                      6.3. Prohibited Content and Examples
                    </h3>
                    <table className="terms-table">
                      <thead>
                        <tr>
                          <th className="terms-table-cell">
                            Category
                          </th>
                          <th className="terms-table-cell">
                            Definition
                          </th>
                          <th className="terms-table-cell">
                            Examples of Prohibited Content
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="terms-table-cell">
                            Hate Speech
                          </td>
                          <td className="terms-table-cell">
                            Content that promotes violence or incites hatred against
                            individuals or groups based on protected characteristics
                          </td>
                          <td className="terms-table-cell">
                            Dehumanizing statements; promoting supremacist ideologies;
                            using hateful symbols; targeting a group based on race or
                            religion
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            Violence &amp; Threats
                          </td>
                          <td className="terms-table-cell">
                            Content that glorifies, incites, or threatens serious
                            physical harm or death
                          </td>
                          <td className="terms-table-cell">
                            Threats of violence against a specific person; content
                            that encourages suicide or self-harm; promoting animal
                            cruelty
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            Graphic Content
                          </td>
                          <td className="terms-table-cell">
                            Gratuitous or shocking depictions of violence, gore, or
                            injury
                          </td>
                          <td className="terms-table-cell">
                            Videos of graphic violence or abuse; depictions of
                            severely mutilated bodies; gruesome images of trauma
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            Sexually Explicit
                          </td>
                          <td className="terms-table-cell">
                            Material that is pornographic or depicts sexual acts for
                            sexual gratification
                          </td>
                          <td className="terms-table-cell">
                            Pornography; depictions of genitalia or nudity for sexual
                            gratification; content that glorifies sexual violence
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            IP Infringement
                          </td>
                          <td className="terms-table-cell">
                            Material that violates copyrights, trademarks, or other
                            intellectual property rights
                          </td>
                          <td className="terms-table-cell">
                            Uploading a song you don't have rights to; using a brand's
                            logo without permission; using uncleared samples in your
                            music
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            Spam &amp; Fraud
                          </td>
                          <td className="terms-table-cell">
                            Content that is misleading, deceptive, or intended to scam
                            or defraud others
                          </td>
                          <td className="terms-table-cell">
                            Fake engagement (bots, scripts); phishing links;
                            impersonating an artist or brand; soliciting payments
                            outside the platform
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            Privacy Violation
                          </td>
                          <td className="terms-table-cell">
                            Sharing another person's private information without their
                            consent
                          </td>
                          <td className="terms-table-cell">
                            Sharing unlisted phone numbers; posting non-consensual
                            intimate content; sharing private health information
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                  {/* 6.4. Tiered System of Enforcement Actions */}
                  <section className="terms-section" id="tiered-enforcement">
                    <h3 className="terms-h3">
                      6.4. Tiered System of Enforcement Actions
                    </h3>
                    <table className="terms-table">
                      <thead>
                        <tr>
                          <th className="terms-table-cell">
                            Violation Type &amp; Severity
                          </th>
                          <th className="terms-table-cell">
                            First Offense
                          </th>
                          <th className="terms-table-cell">
                            Repeated Offenses
                          </th>
                          <th className="terms-table-cell">
                            Severe Offenses
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="terms-table-cell">
                            Minor (e.g., spam, profane comments)
                          </td>
                          <td className="terms-table-cell">
                            Content removal, official warning
                          </td>
                          <td className="terms-table-cell">
                            Temporary account suspension
                          </td>
                          <td className="terms-table-cell">
                            Permanent account termination
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            Serious (e.g., harassment, copyright infringement)
                          </td>
                          <td className="terms-table-cell">
                            Content removal, temporary suspension
                          </td>
                          <td className="terms-table-cell">
                            Permanent account termination
                          </td>
                          <td className="terms-table-cell">
                            Permanent account termination and immediate loss of access
                          </td>
                        </tr>
                        <tr>
                          <td className="terms-table-cell">
                            Critical (e.g., hate speech, violence, fraud, CSAM)
                          </td>
                          <td className="terms-table-cell">
                            Permanent account termination
                          </td>
                          <td className="terms-table-cell">
                            Permanent account termination, immediate loss of access,
                            and potential legal referral
                          </td>
                          <td className="terms-table-cell">
                            Permanent account termination, immediate loss of access to
                            funds and features, and legal referral to authorities
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </section>
      
                {/* Last Updated */}
                <p className="text-sm text-gray-500">
                  <strong>Last Updated:</strong> August 11, 2025
                </p>
    </LegalPageLayout>
  );
}
